import { useAuth0 } from "@auth0/auth0-react";
import { config } from "../utils/configuration/settings";
import { checkUserHasPermission } from "../utils/auth/checkUserHasPermission";
import "./LinkToCg.scss";
import { PERMISSION_TO_DISPLAY_LINK_TO_CURRENT_GEN } from "../constants";

export const LinkToCg = (): JSX.Element => {
  const settings = config.get();

  const { user } = useAuth0();

  return (
    <>
      {checkUserHasPermission(
        user,
        settings.namespace + PERMISSION_TO_DISPLAY_LINK_TO_CURRENT_GEN,
      ) && (
        <a
          href={`${settings.linkToCg}?organization=${user?.org_id}`}
          target="_blank"
          rel="noreferrer"
          className="link"
        >
          Launch C3 Classic
          <i className="bi-box-arrow-up-right ps-2 pe-2"></i>
        </a>
      )}
    </>
  );
};
